import { render } from "./WatchlistItemModal.vue?vue&type=template&id=646159a0&scoped=true"
import script from "./WatchlistItemModal.vue?vue&type=script&lang=js"
export * from "./WatchlistItemModal.vue?vue&type=script&lang=js"

import "./WatchlistItemModal.vue?vue&type=style&index=0&id=646159a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646159a0"]])

export default __exports__